import { render } from "./SlidersPage.vue?vue&type=template&id=c6b8b00e&scoped=true"
import script from "./SlidersPage.vue?vue&type=script&lang=js"
export * from "./SlidersPage.vue?vue&type=script&lang=js"

import "./SlidersPage.vue?vue&type=style&index=0&id=c6b8b00e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b8b00e"]])

export default __exports__